<template>
  <div class="print-wrapper">
    <!-- 物料清单表格 -->
    <table class="material-table">
      <thead>
        <tr>
          <th width="120">当前物料、物料名称</th>
          <th width="100">规格</th>
          <th width="40">单位</th>
          <th width="60">数量</th>
          <th width="60">单价</th>
          <th width="60">金额</th>
          <th width="60">领料数</th>
          <th width="60">仓位</th>
          <th>备注</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in wuliaoData" :key="index">
          <td>{{ index + 1 }}、{{ item.name }}</td>
          <td>{{ item.spec }}</td>
          <td>{{ item.unit }}</td>
          <td>{{ item.counts }}</td>
          <td>{{ item.goods_price }}</td>
          <td>{{ item.goods_amount }}</td>
          <td>{{ item.get_counts }}</td>
          <td>{{ item.warehuose_name }}</td>
          <td>{{ item.remark }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 物料采购表格 -->
    <table class="purchase-table">
      <tbody>
        <tr>
          <th width="120">当前工序、工艺名称</th>
          <th width="100">规格</th>
          <th width="40">单位</th>
          <th width="60">数量</th>
          <th width="60">单价</th>
          <th width="60">金额</th>
          <th width="60">报工数</th>
          <th width="60">工时</th>
          <th>备注</th>
        </tr>
        <tr v-for="(item, index) in [data.gongyiData]" :key="index">
          <td>{{ index + 1 }}、{{ item.name }}</td>
          <td>{{ item.spec }}</td>
          <td>{{ item.unit }}</td>
          <td>{{ item.counts }}</td>
          <td>{{ item.goods_price }}</td>
          <td>{{ item.goods_amount }}</td>
          <td>{{ item.sheng_chan_end_counts }}</td>
          <td>{{ item.gongshi }}</td>
          <td>{{ item.remark }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 质检要求表格 -->
    <table class="inspection-table">
      <thead>
        <tr>
          <th width="120">质检要求</th>
          <th width="149">检测项目</th>
          <th width="129">标准范围</th>
          <th width="129">实测范围</th>
          <th>检测结果</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="index in 2" :key="index">
          <td>{{ index }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PrintTable',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      wuliaoData: []
    }
  },
  mounted() {
    this.initTableData()
  },
  methods: {
    /**
     * 初始化当前物料清单数据
     */
    initTableData() {
      let data = this.data.tableSaleData[0] || {}
      let data1 = []
      let data2 = []

      // 上游物料
      data1 = []
      if (data.tableBomData.length) {
        data.tableBomData.forEach((item) => {
          if (item.tableBomData.length) {
            data1.push(...item.tableBomData)
          } else {
            data1.push(...item.table_data_1)
          }
        })
      } else {
        data1.push(...data.table_data_1)
      }

      // 当前物料
      if (data.tableBomData.length) {
        data2 = data.tableBomData || []
      } else if (data.table_data_2.length) {
        data2 = data.table_data_2 || []
      } else {
        data2 = data.table_data_1 || []
      }

      // 如果工艺名称含有'切管'、'切板'，则取data1，否则取data2
      let name = this.data.gongyiData.name || ''
      if (name.includes('切管') || name.includes('切板')) {
        this.wuliaoData = data1
      } else {
        this.wuliaoData = data2
      }
    }
  }
}
</script>

<style lang="less" scoped>
.print-wrapper {
}

// 物料清单表格
.material-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  th,
  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #e0e5eb;
  }
}

// 物料采购表格
.purchase-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  th,
  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #e0e5eb;
  }
}

// 质检要求表格
.inspection-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  th,
  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #e0e5eb;
  }
}
</style>
